interface IMeQrStorageData {
    storageSize: number; 
    usedStorageSize: number
}

const requestOptions = (userName: string): RequestInit => ({
    method: "POST",
    headers: {"Content-Type": "application/json"},
    body: JSON.stringify({email: userName}),
});

const updateMeQrStorage = async (userName: string): Promise<boolean> => {
    try {
        const response = await fetch(
            `${process.env.REACT_APP_MEQR_ADDRESS}/entry/constructor/user/file_size`,
            requestOptions(userName)
        );
        if (!response.ok) return false;

        const data = await response.json();
        return typeof data?.fileSize === "number";
    } catch (err) {
        console.error("Error updating ME-QR storage:", err);
        return false;
    }
}

const getMeQrStorageSize = async (userName: string): Promise<IMeQrStorageData | null> => {
    try {
        const response = await fetch(
            `${process.env.REACT_APP_MEQR_ADDRESS}/entry/file/user/email/storage_size`,
            requestOptions(userName)
        );
        if (!response.ok) return null;

        const data = await response.json();
        if (typeof data?.usedStorageSize !== "number" || typeof data?.storageSize !== "number") return null;

        return data as IMeQrStorageData;
    } catch (err) {
        console.error("Error fetching storage size:", err);
        return null;
    }
}

export {
    updateMeQrStorage,
    getMeQrStorageSize,
    IMeQrStorageData
}
